import { ArrowUpRight, CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";
import type { NewsPost } from "../types";

export function NewsCard({ post, featured = false }: { post: NewsPost; featured?: boolean }) {
  const date = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "short", year: "numeric" }).format(
    new Date(post.published_at),
  );

  return (
    <article className={`news-card ${featured ? "news-card--featured" : ""}`}>
      <Link to={`/aktuelles/${post.slug}`} className="news-card-image" aria-label={post.title}>
        <img src={post.cover_image || "/images/hero-table-tennis.png"} alt="" loading="lazy" />
        <span className="news-tag">Vereinsnews</span>
        <time className="news-date" dateTime={post.published_at} aria-label={`Veröffentlicht am ${date}`}>
          <CalendarDays size={15} />
          <span>{date}</span>
        </time>
      </Link>
      <div className="news-card-body">
        <h3><Link to={`/aktuelles/${post.slug}`} title={post.title}>{post.title}</Link></h3>
        <p>{post.excerpt}</p>
        <Link to={`/aktuelles/${post.slug}`} className="text-link">Weiterlesen <ArrowUpRight size={16} /></Link>
      </div>
    </article>
  );
}
